import { MenuProps, Typography } from 'antd';
import { memo, useEffect, useMemo, useState } from 'react';

import { BoardInfo, IBoardContentItem } from 'components/BoardInfo/BoardInfo';
import {
  ICustomer,
  IGoldSoldBuyOrder,
  IGoldSoldYBuyOrder,
  IOrder,
  IOrderProcess,
  IOrderStatus,
} from 'interfaces/SalesInfo';
import { Link } from 'react-router-dom';
import path from 'routes/Path';
import { formatCurrency, formatDate } from 'utils/constants/functions';

interface IGeneralInfoTabProps {
  customer: ICustomer;
  orderData: IOrder;
  orderStatus: IOrderStatus;
  orderSAPProcess: IOrderProcess[];
  goldSoldBuyOrderData: IGoldSoldBuyOrder | IGoldSoldYBuyOrder;
  optionMenuItems?: MenuProps['items'];
  // exportMenuProps: TMenuPropsCustom;
}

const { Text } = Typography;

export const GeneralInfoTab = memo(
  ({
    customer,
    orderData,
    // optionMenuItems,
    goldSoldBuyOrderData,
    orderSAPProcess,
    // exportMenuProps,
    orderStatus,
  }: IGeneralInfoTabProps) => {
    const [boardData, setBoardData] = useState([] as IBoardContentItem[]);

    // const optionMenuProps: MenuProps = useMemo(() => {
    //   return {
    //     items: optionMenuItems || [],
    //   };
    // }, [optionMenuItems]);

    const finalPrice = useMemo(() => {
      const finalPrice =
        goldSoldBuyOrderData?.finalPriceSap || goldSoldBuyOrderData?.finalPrice;
      const isValid = finalPrice !== null && finalPrice !== undefined;

      return isValid
        ? `${formatCurrency({
            value: finalPrice || 0,
            round: true,
          })} VND`
        : '-';
    }, [goldSoldBuyOrderData]);

    const typeGold = useMemo(() => {
      return goldSoldBuyOrderData?.orderTempDetail?.[0]?.tproduct?.ttype?.id;
    }, [goldSoldBuyOrderData]);

    useEffect(() => {
      const filtered =
        orderData?.tOrderSeparation?.filter(
          (item) => item.statusId == 'OR02_01' || item.statusId == 'OR02_03',
        ) ?? [];

      setBoardData([
        // orderData?.tOrderSeparation?.[0]?.statusId === 'OR02_03' ||
        filtered.length > 0
          ? {
              title: 'Thông tin đơn',
              children: [
                {
                  content: [
                    {
                      title: filtered.some(
                        (item) => item.statusId === 'OR02_03',
                      )
                        ? 'Mã đơn gộp'
                        : 'Mã đơn tách',
                      content: (
                        <Text className="font-bold">{orderData?.id}</Text>
                      ),
                    },
                  ],
                },
                {
                  content: [],
                },
                {
                  content: [
                    // {
                    //   title: 'Mã đơn tách',
                    //   content: (
                    //     <Text className="font-bold">{orderData?.id}</Text>
                    //   ),
                    // },
                    ...filtered
                      ?.filter((_, index) => index % 2 === 0)
                      .map((item) => {
                        const index = filtered?.findIndex(
                          (orderData) => orderData?.id === item?.id,
                        );

                        return {
                          title: (
                            <Text className="font-bold">
                              Bk {(index || 0) + 1}
                              {/* [{item?.id}] Bảng kê {(index || 0) + 1}: */}
                            </Text>
                          ),
                          content: (
                            <Text>
                              [{item?.id}]{' '}
                              {item?.finalPrice
                                ? formatCurrency({
                                    value: item.finalPrice,
                                    round: true,
                                  })
                                : 0}{' '}
                              VND{' '}
                              <Link
                                to={`${path.SALES_INVOICE_DETAIL}?orderId=${item?.id}&orderTypeId=${item?.orderTypeId}`}
                                target="_blank"
                                className="font-bold !text-primary-60"
                              >
                                Xem chi tiết
                              </Link>
                            </Text>
                          ),
                        };
                      }),
                    // {
                    //   title: 'Trạng thái',
                    //   content: (
                    //     <p
                    //       className={classNames(
                    //         'font-bold',
                    //         orderStatus.status
                    //           ? 'text-[#0077CC]'
                    //           : 'text-[#eb3455]',
                    //       )}
                    //     >
                    //       {orderStatus.message}
                    //     </p>
                    //   ),
                    // },
                  ],
                },

                {
                  content: [
                    // {
                    //   title: 'SO',
                    //   content:
                    //     orderSAPProcess.find(
                    //       (orderProcess) =>
                    //         orderProcess?.processStatus?.id === 'SO',
                    //     )?.processId ?? '',
                    // },
                    ...filtered
                      ?.filter((_, index) => index % 2 !== 0)
                      .map((item) => {
                        const index = filtered?.findIndex(
                          (orderData) => orderData?.id === item?.id,
                        );

                        return {
                          title: (
                            <Text className="font-bold">
                              Bk {(index || 0) + 1}
                              {/* [{item?.id}] Bảng kê {(index || 0) + 1}: */}
                            </Text>
                          ),
                          content: (
                            <Text>
                              [{item?.id}]{' '}
                              {item?.finalPrice
                                ? formatCurrency({
                                    value: item.finalPrice,
                                    round: true,
                                  })
                                : 0}{' '}
                              VND{' '}
                              <Link
                                to={`${path.SALES_INVOICE_DETAIL}?orderId=${item?.id}&orderTypeId=${item?.orderTypeId}`}
                                target="_blank"
                                className="font-bold !text-primary-60"
                              >
                                Xem chi tiết
                              </Link>
                            </Text>
                          ),
                        };
                      }),
                    // {
                    //   title: 'HĐĐT',
                    //   content:
                    //     orderSAPProcess.find(
                    //       (orderProcess) =>
                    //         orderProcess?.processStatus?.id === 'EINVOICE',
                    //     )?.processId ?? '',
                    // },
                  ],
                },
              ],
            }
          : {
              title: 'Thông tin đơn',
              children: [
                {
                  content: [
                    {
                      title: 'DMS',
                      content: (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                          }}
                        >
                          <span>{orderData?.id}</span>
                          {orderData.isSyncFromSap && (
                            <span
                              style={{
                                backgroundColor: '#002D62',
                                color: 'white',
                                borderRadius: '999px',
                                padding: '2px 12px',
                                fontSize: '12px',
                                display: 'inline-block',
                              }}
                            >
                              SAP
                            </span>
                          )}
                        </div>
                      ),
                    },
                    {
                      title: 'HĐĐT',
                      content:
                        orderSAPProcess.find(
                          (orderProcess) =>
                            orderProcess?.processStatus?.id === 'EINVOICE',
                        )?.processId ?? '',
                    },
                  ],
                },
                {
                  content: [
                    {
                      title: 'SO',
                      content:
                        orderSAPProcess.find(
                          (orderProcess) =>
                            orderProcess?.processStatus?.id === 'SO',
                        )?.processId ?? '',
                    },
                    // {
                    //   title: 'Trạng thái',
                    //   content: (
                    //     <p
                    //       className={classNames(
                    //         'font-bold',
                    //         orderStatus.status
                    //           ? 'text-[#0077CC]'
                    //           : 'text-[#eb3455]',
                    //       )}
                    //     >
                    //       {orderStatus.message}
                    //     </p>
                    //   ),
                    // },
                  ],
                },
              ],
            },
        {
          title: 'Khách hàng',
          children: [
            {
              content: [
                {
                  title: 'Mã KH SAP',
                  content: (
                    <Text className="font-bold">{customer?.sapCustomerId}</Text>
                  ),
                },
                {
                  title: 'Tên KH',
                  content: (
                    <Text className="font-bold">{customer?.storeName}</Text>
                  ),
                },
                // {
                //   title: 'MST',
                //   content: customer?.taxId,
                // },
                // {
                //   title: 'Đại diện',
                //   content: 'Đại diện',
                // },
                // {
                //   title: 'CCCD',
                //   content: customer?.cccd,
                // },
                // {
                //   title: 'Địa chỉ',
                //   content: customer?.address,
                // },
              ],
            },
            {
              content: [
                {
                  title: 'Mã KH DMS',
                  content: <Text className="font-bold">{customer?.id}</Text>,
                },
                {
                  title: 'Loại KH',
                  content: (
                    <Text className="font-bold">{customer?.trank?.name}</Text>
                  ),
                },
                // {
                //   title: '',
                //   content: '',
                // },
                // {
                //   title: 'SĐT',
                //   content: customer?.phone,
                // },
              ],
            },
          ],
        },
        {
          title: 'Thông tin thanh toán',
          children: [
            {
              content: [
                {
                  title: 'SL Sản phẩm',
                  content: (
                    <Text className="font-bold">
                      {goldSoldBuyOrderData?.totalQuantity}
                    </Text>
                  ),
                },
                {
                  title: 'Giá bóng',
                  content: (
                    <Text className="font-bold">
                      {orderData?.marketGoldPrice
                        ? `${formatCurrency({ value: orderData?.marketGoldPrice, round: true })} VND`
                        : ''}
                    </Text>
                  ),
                },
                {
                  title: 'Tiền Vàng',
                  content: (
                    <Text className="font-bold">
                      {typeGold === 'T' && orderData?.totalGoldPrice
                        ? `${formatCurrency({ value: orderData?.totalGoldPrice, round: true })} VND`
                        : '-'}
                    </Text>
                  ),
                },
              ],
            },
            {
              content: [
                {
                  title: 'Q10',
                  content: (
                    <Text className="font-bold">
                      {'totalQ10' in goldSoldBuyOrderData
                        ? Number(goldSoldBuyOrderData?.totalQ10 ?? 0).toFixed(3)
                        : 0}
                    </Text>
                  ),
                },
                {
                  title: 'Giá bóng TT',
                  content: (
                    <Text className="font-bold">
                      {orderData?.dealPrice?.dealPrice
                        ? `${formatCurrency({
                            value: orderData.dealPrice.dealPrice,
                            round: true,
                          })} VND`
                        : '-'}
                    </Text>
                  ),
                },
                {
                  title: 'Chiết khấu',
                  content: (
                    <Text className="font-bold">
                      {orderData?.totalDiscount
                        ? `${formatCurrency({
                            value: orderData?.totalDiscount,
                            round: true,
                          })} VND`
                        : 0}
                    </Text>
                  ),
                },
              ],
            },
          ],
        },
        {
          title: '',
          children: [],
        },
        orderData.orderTypeId === 'A109_02'
          ? {
              title: '',
              children: [
                {
                  content: [
                    {
                      title: 'Tổng giá trị',
                      content: (
                        <Text className="font-bold">
                          {goldSoldBuyOrderData?.finalPrice
                            ? `${formatCurrency({
                                value: goldSoldBuyOrderData.finalPrice,
                                round: true,
                              })} VND`
                            : '0'}
                        </Text>
                      ),
                    },
                  ],
                },
                {
                  content: [
                    {
                      title: 'Thành tiền sau CK',
                      content: <Text className="font-bold">{finalPrice}</Text>,
                    },
                  ],
                },
              ],
            }
          : {
              title: '',
              children: [
                {
                  content: [
                    {
                      title: 'Tiền món',
                      content: (
                        <Text className="font-bold">
                          {typeGold === 'M'
                            ? `${formatCurrency({
                                value: orderData?.totalPrice,
                                round: true,
                              })} VND`
                            : '0'}
                        </Text>
                      ),
                    },
                    {
                      title: 'T.T món',
                      content: (
                        <Text className="font-bold">
                          {typeGold === 'M' ? finalPrice : '0'}
                        </Text>
                      ),
                    },
                  ],
                },
                {
                  content: [
                    {
                      title: 'Tiền công',
                      content: (
                        <Text className="font-bold">
                          {typeGold === 'T'
                            ? `${formatCurrency({
                                value: (
                                  goldSoldBuyOrderData as IGoldSoldBuyOrder
                                )?.processPriceSap,
                                // value: orderData?.totalProcessPrice,
                                round: true,
                              })} VND`
                            : '0'}
                        </Text>
                      ),
                    },
                    {
                      title: 'T.T công + vàng',
                      content: (
                        <Text className="font-bold">
                          {typeGold === 'T' ? finalPrice : '0'}
                        </Text>
                      ),
                    },
                  ],
                },
              ],
            },
        {
          title: 'Ghi chú',
          index: 4,
          children: [
            {
              content: [
                {
                  title: '',
                  content: orderData?.marketNote,
                },
              ],
            },
          ],
        },
        {
          title: 'Thông tin lịch sử',
          index: 5,
          children: [
            {
              content: [
                {
                  title: 'Ngày tạo',
                  content: (
                    <Text className="font-bold">
                      {orderData?.createDate
                        ? formatDate(orderData.createDate)
                        : '-'}
                    </Text>
                  ),
                },
                {
                  title: 'Ngày cập nhật',
                  content: (
                    <Text className="font-bold">
                      {orderData?.modifyDate
                        ? formatDate(orderData.modifyDate)
                        : '-'}{' '}
                    </Text>
                  ),
                },
              ],
            },
            {
              content: [
                {
                  title: 'Người tạo',
                  content: orderData?.createName ?? '-',
                },
                {
                  title: 'Người cập nhật',
                  content: orderData?.modifyName ?? '-',
                },
              ],
            },
          ],
        },
      ]);
    }, [
      orderData,
      customer,
      goldSoldBuyOrderData,
      finalPrice,
      typeGold,
      orderSAPProcess,
      orderStatus,
    ]);

    // const isDisabledButton = useMemo(() => {
    //   try {
    //     return Object.keys(goldSoldBuyOrderData || {}).length <= 0;
    //   } catch {
    //     return true;
    //   }
    // }, [goldSoldBuyOrderData]);

    return (
      <>
        {/* <Row gutter={[9, 0]} justify={'end'} align={'middle'}>
          <Col>
            <ExportOptionsButton
              menuProps={exportMenuProps}
              disabled={Object.keys(goldSoldBuyOrderData || {}).length <= 0}
            />
          </Col>
          <Col>
            <OptionsMenu menu={optionMenuProps} disabled={isDisabledButton} />
          </Col>
        </Row> */}
        <BoardInfo data={boardData} />
      </>
    );
  },
);
